import { getService } from '../utils';

export async function markWarningAsNotified(): Promise<void> {
  const dataService = getService('softwareUpdate')();

  await dataService.create({
    lastWarningNotified: true,
  });
}
